<template>
  <div>
    <div class="pb-2">
      <span v-if="isProfilePage">
        <i class="fas fa-lock" style="color: goldenrod"></i>
        非公開情報も含めて表示中
      </span>
      <span v-else>
        <a href="/users/profile">
          <i class="fas fa-user"></i>
          非公開情報も含めて表示する
        </a>
      </span>
      <br />
      <span v-if="kind !== 'grass'">
        <i class="fas fa-lock" style="color: goldenrod"></i>
        この種類のグラフは自分のみ閲覧可能
      </span>
    </div>
    <select v-model="kind" class="form-control">
      <option value="grass">{{isProfilePage ? '🔒' : '🌏'}} カレンダー</option>
      <option value="week_count">🔒 曜日 x 回数</option>
      <option value="week_score">🔒 曜日 x スコア平均</option>
      <option value="range_count">🔒 時間帯 x 回数</option>
      <option value="range_score">🔒 時間帯 x スコア平均</option>
    </select>
    <grass :mags="mags" v-if="kind === 'grass'" />
    <bar :chartData="chartData" :height="260" v-else />
    <div class="text-center">
      <small style="color: gray;">
        午前5時以前は前日カウントです
      </small>
    </div>
  </div>
</template>

<script>
import Bar from './bar.js'
import Colors from './_colors.json'
import Grass from '../charts/_grass'
const DayOfWeeks = ['月', '火', '水', '木', '金', '土', '日']
const TimeRanges = Array(12).fill().map((x, i) => `${i * 2}-${i * 2 + 2}`)

export default {
  components: { Bar, Grass },
  props: ['mags', 'isProfilePage'],
  data() {
    return { kind: 'grass' }
  },
  methods: {
  },
  computed: {
    chartData() {
      const columns = this.kind.includes('week') ? DayOfWeeks : TimeRanges
      const matchName = this.kind.includes('week') ? 'day_of_week' : 'time_range'
      const label = this.kind.includes('count') ? 'まぐわった数' : 'スコア平均'
      return {
        labels: columns,
        datasets: [{
          label: label,
          data: columns.map(column => {
            const mags = this.mags.filter(mag => column == mag[matchName])
            if (this.kind.includes('count')) {
              return mags.length
            } else {
              const scores = mags.map(mag => mag.score).filter(score => Number.isInteger(score))
              return scores.reduce((a, b) => a + b, 0) / scores.length
            }
          }),
          backgroundColor: Colors[0],
          borderColor: Colors[0]
        }]
      }
    },
    timeRanges() { return TimeRanges }
  }
}
</script>

<style scoped>
</style>
